export enum SidebarTypes {
	HANDLE_SIDEBAR = '@sidebar/HANDLE_SIDEBAR',
}

export interface ISidebarInitSstate {
	isHidden: boolean;
}
